/**
 * The one HTML escaper.
 *
 * There were three: a `switch` in CombatHUD, a ternary chain called `esc` in
 * CharacterSheet, and another `escapeHtml` in ScrimPanel — same regex, same
 * five entities, three bodies, two names. The two spellings are the part that
 * bites: a grep for `escapeHtml` misses one of them entirely.
 *
 * Escaping belongs at the boundary where a string becomes markup, regardless of
 * who wrote the string. Most of what these render is our own roster copy, but
 * display names are not — and a rule that only applies to untrusted strings is
 * a rule someone has to remember to apply.
 */
export function escapeHtml(text) {
  return String(text).replace(/[&<>"']/g, (c) => {
    switch (c) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      default:
        return '&#39;';
    }
  });
}
